import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Bell, Search, MessageCircle, Newspaper } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

export const MobileNavigation = ({ unreadCount = 0, unreadNotifications = 0 }) => {
  const { user } = useAuth();
  const location = useLocation();
  
  if (!user) return null;
  
  const navItems = [
    { 
      path: '/feed', 
      icon: Newspaper, 
      label: 'Fil',
      badge: 0
    },
    { 
      path: '/search', 
      icon: Search, 
      label: 'Recherche',
      badge: 0
    },
    { 
      path: '/messages', 
      icon: MessageCircle, 
      label: 'Messages',
      badge: unreadCount,
      badgeColor: 'bg-gold text-dark'
    },
    { 
      path: '/notifications', 
      icon: Bell, 
      label: 'Notifs',
      badge: unreadNotifications,
      badgeColor: 'bg-red-500'
    },
  ];
  
  return (
    <nav 
      className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-dark-paper/95 backdrop-blur-lg border-t border-white/10 safe-area-bottom"
      data-testid="mobile-navigation"
    >
      <div className="flex items-center justify-around h-16 px-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center flex-1 py-2 relative transition-colors ${
                isActive ? 'text-gold' : 'text-gray-400'
              }`}
              data-testid={`mobile-nav-${item.label.toLowerCase()}`}
            >
              <div className="relative">
                <Icon className={`w-6 h-6 ${isActive ? 'text-gold' : ''}`} />
                {item.badge > 0 && (
                  <span className={`absolute -top-1 -right-2 min-w-[18px] h-[18px] ${item.badgeColor || 'bg-gold text-dark'} text-xs font-bold rounded-full flex items-center justify-center px-1`}>
                    {item.badge > 9 ? '9+' : item.badge}
                  </span>
                )}
              </div>
              <span className={`text-[10px] mt-1 ${isActive ? 'text-gold font-medium' : ''}`}>
                {item.label}
              </span>
              {isActive && (
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-gold rounded-full" />
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileNavigation;
